import { render } from "./LinkScanButton.vue?vue&type=template&id=ab145c36"
import script from "./LinkScanButton.vue?vue&type=script&lang=ts"
export * from "./LinkScanButton.vue?vue&type=script&lang=ts"
script.render = render

export default script